import { render } from "./AddInventoryItemStock.vue?vue&type=template&id=5bc6f85b"
import script from "./AddInventoryItemStock.vue?vue&type=script&lang=js"
export * from "./AddInventoryItemStock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__